import React from 'react';

// Componente SVG Avatar
const AvatarSVG = ({ type, color, size = 64, avatarId }) => {
  const s = size;

  // Astronauta
  if (avatarId === 'astronaut') {
    return (
      <svg width={s} height={s} viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="32" r="30" fill={color} />
        <ellipse cx="32" cy="28" rx="16" ry="18" fill="white" />
        <ellipse cx="32" cy="28" rx="12" ry="14" fill="#87CEEB" opacity="0.5" />
        <circle cx="28" cy="26" r="2" fill="#333" />
        <circle cx="36" cy="26" r="2" fill="#333" />
        <path d="M29 32 Q32 35 35 32" stroke="#333" strokeWidth="1.5" fill="none" strokeLinecap="round" />
        <rect x="14" y="44" width="8" height="12" rx="2" fill="white" />
        <rect x="42" y="44" width="8" height="12" rx="2" fill="white" />
        <circle cx="18" cy="28" r="3" fill="#FF6B6B" />
      </svg>
    );
  }

  // Robot
  if (avatarId === 'robot') {
    return (
      <svg width={s} height={s} viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="32" r="30" fill={color} />
        <rect x="16" y="18" width="32" height="28" rx="4" fill="#C0C0C0" />
        <rect x="20" y="24" width="8" height="8" rx="1" fill="#00FF00" />
        <rect x="36" y="24" width="8" height="8" rx="1" fill="#00FF00" />
        <rect x="24" y="38" width="16" height="4" rx="1" fill="#333" />
        <rect x="26" y="38" width="3" height="4" fill="#C0C0C0" />
        <rect x="31" y="38" width="3" height="4" fill="#C0C0C0" />
        <rect x="36" y="38" width="3" height="4" fill="#C0C0C0" />
        <rect x="28" y="8" width="8" height="10" rx="2" fill="#C0C0C0" />
        <circle cx="32" cy="10" r="3" fill="#FF0000" />
      </svg>
    );
  }

  // Ninja
  if (avatarId === 'ninja') {
    return (
      <svg width={s} height={s} viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="32" r="30" fill={color} />
        <circle cx="32" cy="28" r="14" fill="#FCD7B6" />
        <rect x="14" y="22" width="36" height="12" fill="#1F2937" />
        <circle cx="26" cy="28" r="3" fill="white" />
        <circle cx="38" cy="28" r="3" fill="white" />
        <circle cx="26" cy="28" r="1.5" fill="#333" />
        <circle cx="38" cy="28" r="1.5" fill="#333" />
        <path d="M44 26 L54 20" stroke="#1F2937" strokeWidth="3" />
        <path d="M44 30 L54 36" stroke="#1F2937" strokeWidth="3" />
      </svg>
    );
  }

  // Cientifico
  if (avatarId === 'scientist') {
    return (
      <svg width={s} height={s} viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="32" r="30" fill={color} />
        <circle cx="32" cy="26" r="12" fill="#FCD7B6" />
        <path d="M20 56 C20 42 44 42 44 56" fill="white" />
        <ellipse cx="26" cy="24" rx="5" ry="4" fill="white" stroke="#333" strokeWidth="1" />
        <ellipse cx="38" cy="24" rx="5" ry="4" fill="white" stroke="#333" strokeWidth="1" />
        <circle cx="26" cy="24" r="2" fill="#333" />
        <circle cx="38" cy="24" r="2" fill="#333" />
        <path d="M22 16 Q32 10 42 16" stroke="#E5E5E5" strokeWidth="3" fill="none" />
        <path d="M29 32 Q32 34 35 32" stroke="#333" strokeWidth="1.5" fill="none" strokeLinecap="round" />
      </svg>
    );
  }

  // Artista
  if (avatarId === 'artist') {
    return (
      <svg width={s} height={s} viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="32" r="30" fill={color} />
        <circle cx="32" cy="26" r="12" fill="#FCD7B6" />
        <ellipse cx="32" cy="10" rx="14" ry="6" fill="#FFD700" />
        <circle cx="28" cy="24" r="2" fill="#333" />
        <circle cx="36" cy="24" r="2" fill="#333" />
        <path d="M29 30 Q32 33 35 30" stroke="#333" strokeWidth="1.5" fill="none" strokeLinecap="round" />
        <circle cx="48" cy="44" r="8" fill="#8B4513" />
        <circle cx="45" cy="40" r="2" fill="#FF0000" />
        <circle cx="51" cy="40" r="2" fill="#00FF00" />
        <circle cx="48" cy="46" r="2" fill="#0000FF" />
        <circle cx="45" cy="46" r="2" fill="#FFFF00" />
      </svg>
    );
  }

  // Chef
  if (avatarId === 'chef') {
    return (
      <svg width={s} height={s} viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="32" r="30" fill={color} />
        <circle cx="32" cy="28" r="12" fill="#FCD7B6" />
        <ellipse cx="32" cy="10" rx="12" ry="8" fill="white" />
        <circle cx="24" cy="8" r="5" fill="white" />
        <circle cx="40" cy="8" r="5" fill="white" />
        <circle cx="32" cy="6" r="5" fill="white" />
        <circle cx="28" cy="26" r="2" fill="#333" />
        <circle cx="36" cy="26" r="2" fill="#333" />
        <path d="M28 34 Q32 37 36 34" stroke="#333" strokeWidth="1.5" fill="none" strokeLinecap="round" />
        <path d="M26 32 Q28 30 30 32" stroke="#D4A574" strokeWidth="1" fill="none" />
      </svg>
    );
  }

  // Pirata
  if (avatarId === 'pirate') {
    return (
      <svg width={s} height={s} viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="32" r="30" fill={color} />
        <circle cx="32" cy="28" r="12" fill="#FCD7B6" />
        <rect x="18" y="14" width="28" height="6" fill="#1F2937" />
        <ellipse cx="32" cy="14" rx="10" ry="4" fill="#1F2937" />
        <circle cx="26" cy="26" r="5" fill="#1F2937" />
        <circle cx="38" cy="26" r="2" fill="#333" />
        <path d="M28 34 Q32 37 36 34" stroke="#333" strokeWidth="1.5" fill="none" strokeLinecap="round" />
        <rect x="22" y="24" width="8" height="1" fill="#FFD700" />
      </svg>
    );
  }

  // Superheroe
  if (avatarId === 'superhero') {
    return (
      <svg width={s} height={s} viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="32" r="30" fill={color} />
        <circle cx="32" cy="26" r="12" fill="#FCD7B6" />
        <path d="M18 56 C18 42 46 42 46 56" fill="#B91C1C" />
        <path d="M20 24 L26 20 L32 26 L38 20 L44 24" stroke="#B91C1C" strokeWidth="3" fill="none" />
        <rect x="20" y="22" width="24" height="8" rx="2" fill="#B91C1C" />
        <circle cx="28" cy="26" r="2" fill="white" />
        <circle cx="36" cy="26" r="2" fill="white" />
        <path d="M29 32 Q32 34 35 32" stroke="#333" strokeWidth="1.5" fill="none" strokeLinecap="round" />
        <polygon points="32,44 28,56 32,52 36,56" fill="#FFD700" />
      </svg>
    );
  }

  // Gato
  if (avatarId === 'cat') {
    return (
      <svg width={s} height={s} viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="32" r="30" fill={color} />
        <circle cx="32" cy="32" r="16" fill="#FFA500" />
        <polygon points="18,20 22,32 14,32" fill="#FFA500" />
        <polygon points="46,20 42,32 50,32" fill="#FFA500" />
        <ellipse cx="26" cy="30" rx="3" ry="4" fill="#90EE90" />
        <ellipse cx="38" cy="30" rx="3" ry="4" fill="#90EE90" />
        <circle cx="26" cy="30" r="1.5" fill="#333" />
        <circle cx="38" cy="30" r="1.5" fill="#333" />
        <ellipse cx="32" cy="36" rx="2" ry="1.5" fill="#FFB6C1" />
        <path d="M30 38 Q32 40 34 38" stroke="#333" strokeWidth="1" fill="none" />
        <path d="M20 34 L8 32" stroke="#333" strokeWidth="1" />
        <path d="M20 36 L8 38" stroke="#333" strokeWidth="1" />
        <path d="M44 34 L56 32" stroke="#333" strokeWidth="1" />
        <path d="M44 36 L56 38" stroke="#333" strokeWidth="1" />
      </svg>
    );
  }

  // Perro
  if (avatarId === 'dog') {
    return (
      <svg width={s} height={s} viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="32" r="30" fill={color} />
        <circle cx="32" cy="32" r="16" fill="#D2691E" />
        <ellipse cx="18" cy="24" rx="6" ry="10" fill="#D2691E" />
        <ellipse cx="46" cy="24" rx="6" ry="10" fill="#D2691E" />
        <circle cx="26" cy="28" r="3" fill="white" />
        <circle cx="38" cy="28" r="3" fill="white" />
        <circle cx="26" cy="28" r="1.5" fill="#333" />
        <circle cx="38" cy="28" r="1.5" fill="#333" />
        <ellipse cx="32" cy="36" rx="4" ry="3" fill="#333" />
        <path d="M28 42 Q32 46 36 42" stroke="#333" strokeWidth="2" fill="none" />
        <ellipse cx="32" cy="44" rx="3" ry="2" fill="#FF69B4" />
      </svg>
    );
  }

  // Zorro
  if (avatarId === 'fox') {
    return (
      <svg width={s} height={s} viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="32" r="30" fill={color} />
        <circle cx="32" cy="34" r="14" fill="#FF6B35" />
        <polygon points="16,18 24,34 12,34" fill="#FF6B35" />
        <polygon points="48,18 40,34 52,34" fill="#FF6B35" />
        <polygon points="16,18 24,34 18,28" fill="#FFF" />
        <polygon points="48,18 40,34 46,28" fill="#FFF" />
        <ellipse cx="32" cy="42" rx="8" ry="6" fill="white" />
        <circle cx="26" cy="32" r="2" fill="#333" />
        <circle cx="38" cy="32" r="2" fill="#333" />
        <ellipse cx="32" cy="38" rx="2" ry="1.5" fill="#333" />
      </svg>
    );
  }

  // Panda
  if (avatarId === 'panda') {
    return (
      <svg width={s} height={s} viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="32" r="30" fill={color} />
        <circle cx="32" cy="32" r="18" fill="white" />
        <circle cx="18" cy="20" r="8" fill="#333" />
        <circle cx="46" cy="20" r="8" fill="#333" />
        <ellipse cx="24" cy="28" rx="6" ry="7" fill="#333" />
        <ellipse cx="40" cy="28" rx="6" ry="7" fill="#333" />
        <circle cx="24" cy="28" r="2" fill="white" />
        <circle cx="40" cy="28" r="2" fill="white" />
        <ellipse cx="32" cy="38" rx="4" ry="3" fill="#333" />
        <path d="M28 42 Q32 45 36 42" stroke="#333" strokeWidth="1.5" fill="none" />
      </svg>
    );
  }

  // Male classic
  if (type === 'male' || type === 'M') {
    return (
      <svg width={s} height={s} viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="32" r="30" fill={color} />
        <circle cx="32" cy="24" r="12" fill="#FCD7B6" />
        <path d="M20 56 C20 42 44 42 44 56" fill="#FCD7B6" />
        <path d="M22 18 Q32 8 42 18 Q42 24 32 26 Q22 24 22 18" fill="#5D4037" />
        <circle cx="27" cy="23" r="2" fill="#333" />
        <circle cx="37" cy="23" r="2" fill="#333" />
        <path d="M28 30 Q32 33 36 30" stroke="#333" strokeWidth="1.5" fill="none" strokeLinecap="round" />
      </svg>
    );
  }

  // Female classic
  if (type === 'female' || type === 'F') {
    return (
      <svg width={s} height={s} viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="32" r="30" fill={color} />
        <circle cx="32" cy="24" r="12" fill="#FCD7B6" />
        <path d="M18 56 C18 40 46 40 46 56" fill="#FCD7B6" />
        <path d="M16 22 Q18 10 32 12 Q46 10 48 22 Q48 32 44 36 L40 28 Q32 32 24 28 L20 36 Q16 32 16 22" fill="#5D4037" />
        <circle cx="27" cy="23" r="2" fill="#333" />
        <circle cx="37" cy="23" r="2" fill="#333" />
        <path d="M29 30 Q32 33 35 30" stroke="#333" strokeWidth="1.5" fill="none" strokeLinecap="round" />
        <circle cx="24" cy="27" r="2" fill="#FFB6C1" opacity="0.6" />
        <circle cx="40" cy="27" r="2" fill="#FFB6C1" opacity="0.6" />
      </svg>
    );
  }

  // Neutral / Default
  return (
    <svg width={s} height={s} viewBox="0 0 64 64" fill="none">
      <circle cx="32" cy="32" r="30" fill={color} />
      <circle cx="32" cy="26" r="11" fill="#FCD7B6" />
      <path d="M20 56 C20 44 44 44 44 56" fill="#FCD7B6" />
      <circle cx="28" cy="25" r="2" fill="#333" />
      <circle cx="36" cy="25" r="2" fill="#333" />
      <path d="M29 31 Q32 33 35 31" stroke="#333" strokeWidth="1.5" fill="none" strokeLinecap="round" />
    </svg>
  );
};

export default AvatarSVG;
